<div class="dropdown">
    <a class="form-control subheader w-auto text-truncate" data-bs-toggle="dropdown" aria-expanded="false"
        translate="Button.Options">
        <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
    </a>
    <div class="dropdown w-auto d-flex">
        <ul class="dropdown-menu">
            <li *ngIf="changeOwnerAllowed()"><a class="dropdown-item" (click)="applyAction('become-owner')"
                    translate="dashboard.Options.BecomeOwner"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('download')" [ngClass]="{ 'disabled': !downloadAllowed()}"
                    translate="dashboard.Options.Download"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('export')" [ngClass]="{ 'disabled': !exportAllowed()}"
                    translate="dashboard.Options.Export"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('withdraw')" [ngClass]="{ 'disabled': !withdrawAllowed()}"
                    translate="dashboard.Options.Withdraw"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('purge')" [ngClass]="{ 'disabled': !purgeAllowed()}"
                    translate="dashboard.Options.Purge"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('delete')" [ngClass]="{ 'disabled': !deleteAllowed()}"
                    translate="dashboard.Options.Delete"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('restore')" [ngClass]="{ 'disabled': !restoreAllowed()}"
                    translate="dashboard.Options.Restore"></a></li>
            <li><a class="dropdown-item" (click)="applyAction('send-reminder')"
                    [ngClass]="{ 'disabled': !sendReminderAllowed()}" translate="dashboard.Options.SendReminder"></a>
            </li>
            <li><a class="dropdown-item" (click)="applyAction('change-workgroup')"
                    [ngClass]="{ 'disabled': !changeWorkgroupAllowed()}"
                    translate="dashboard.Options.ChangeWorkgroup"></a></li>
        </ul>
    </div>
</div>